import $api from "http"

class ReportService {
    static createReport = async (data) => {
        const result = await $api.post(`/api/report`, data)
        return result.data
    }
}

export default ReportService